var $ = jQuery.noConflict();

$(function(){
  var checkboxs = $('input[type=checkbox]');

  checkboxs.each(function(){
    $(this).wrap('<div class="customCheckbox"></div>');
    $(this).before('<span>&#10004;</span>');
  });

  checkboxs.change(function(){
    if($(this).is(':checked')){
     $(this).parent().addClass('customCheckboxChecked');
    } else {
     $(this).parent().removeClass('customCheckboxChecked');
    }
  });
})

/* add quotation mark to blockquote */
function blockquote() {
    var checkmark = '<svg class="quotation-mark" xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18"><path id="iconmonstr-quote-3_1_" data-name="iconmonstr-quote-3 (1)" d="M9.983,3v7.391c0,5.7-3.731,9.57-8.983,10.609L0,18.849A6.616,6.616,0,0,0,4,13H0V3H9.983ZM24,3v7.391c0,5.7-3.748,9.571-9,10.609l-1-2.151A6.615,6.615,0,0,0,18,13H14.017V3H24Z" transform="translate(0 -3)" fill="#d5d8e5"/></svg>';
    jQuery('blockquote').prepend(checkmark);
    console.log('checkmark');
}


function wpcfResponseMove() {
  if(jQuery(".wpcf7-response-output").length > 0){

    $('.wpcf7-response-output').each(function() {
      var responsehtml = $(this).addClass('col-12').addClass('col-lg-10').clone();
      console.log(responsehtml);
      $(this).closest('.wpcf7').find('.acceptance-column').before(responsehtml);
      $(this).closest('.wpcf7').find('.wpcf7-form > .wpcf7-response-output').remove();
    });
  }
  document.addEventListener( 'wpcf7invalid', function( event ) {
    setTimeout(function () {
      jQuery(".wpcf7-response-output").wrapInner( "<div class='response-inner'></div>");
    }, 10);
  }, false );
}

/* Make #content padding top whene use fixed menu - engine.js */
function fixedTopForHeader() {
    var getheight = jQuery('header#header').outerHeight();

    if ($(window).width() >= 992) {
        jQuery('#content').css('padding-top', getheight);
    } else {
        jQuery('#content').css('padding-top', '0');
    }
}

/* double background  */

function doubleBackground() {
  jQuery('.double-background').each(function() {
    var dbWidgetHeight = jQuery(this).closest('.widget').height();
    var dbNextWidgetHeight = jQuery(this).closest('.widget').next('.widget').height();
    jQuery(this).find('.background-image').height( dbWidgetHeight + dbNextWidgetHeight);
    // console.log('dbwidget'+dbWidgetHeight);
    // console.log('dbwidgetNext'+dbNextWidgetHeight);
  });
}

// sticky menu
function navbarSticky() {
    var scrollPosition = jQuery('header#header').offset().top;
    if (scrollPosition > 50) {
        // when scroll to bottom of the page
        jQuery('header#header').addClass('sticky');


    } else {
        jQuery('header#header').removeClass('sticky');
    }
    jQuery(window).on("scroll", function () {
        var scrollPosition = jQuery(window).scrollTop();
        if (scrollPosition > 50) {
            // when scroll to bottom of the page
            jQuery('header#header').addClass('sticky');
        } else {
            jQuery('header#header').removeClass('sticky');
        }
    });
}

// widgets spacing
function widgetSpacing() {
  jQuery('.widget-padding-normal').closest('.widget').addClass('widget-padding-normal-outer');
  jQuery('.widget-padding').closest('.widget').addClass('widget-padding-outer');
  jQuery('.widget-nomargin').closest('.widget').addClass('widget-nomargin-outer');
}


/*
*   BOOTSTRAP
* */

/* Bootstrap - on hover show (slide) submenu - engine.js */
function toggleNavbarMethod() {
    jQuery(function ($) {
        if ($(window).width() > 769) { // ograniczenie dla mobile menu
            $('.dropdown').on('hover', function () {
                $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

            }, function () {
                $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();
            });
            $('.dropdown > a').on('click tap',function () {
                //location.href = this.href;
            });
        }
    });
}

/* Bootstrap -  set same height for all .col* in .row-eq-height - engine.js */
function rowEQheight() {
    jQuery('.row-eq-height').each(function () {
        jQuery(this).children("[class*=' col']").height('auto');
        if ($(window).width() > 992) {
            var seth = 0;
            jQuery(this).children("[class*=' col']").each(function () {
                newh = jQuery(this).height();
                if (newh > seth) {
                    seth = newh;
                }
            });
            jQuery(this).children("[class*=' col']").height(seth);
        } else {
            jQuery(this).children("[class*=' col']").height('auto');
        }
    });
}

/* Bootstrap - full width element .full_width_element when use container for all page */
function fullWidthElement() {
    var wrapper = jQuery('body');
    jQuery('.full_width_element').each(function () {
        jQuery(this).css({
            "margin-left": 0,
            "margin-right": 0,
            "padding-left": 0,
            "padding-right": 0
        })
        var left = jQuery(this).offset().left;
        var right = jQuery(this).offset().right;
        jQuery(this).css({
            "margin-left": -left,
            "margin-right": -left
        })
        if (jQuery('.slick-slider-page').length) {
            jQuery('.slick-slider-page').slick('reinit');
        }
    });

}

/* Bootstrap - scroll to colapsed element in acordeon */
function scrollToColapsedElement(){
    jQuery(".panel-default").on('shown.bs.collapse', function() {
        jQuery('html,body').animate({
                scrollTop: $(this).children('.panel-collapse').offset().top-200},
            'slow');
    });
}

/*
* WAYPOINT ANIMATE CSS
* */

function is_touch_device() {
    return 'ontouchstart' in window // works on most browsers
        || 'onmsgesturechange' in window; // works on ie10
}


function navbarMagic() {
        ///////////////// hide menu after scroll
        // Hide Header on on scroll down
        // var mainheader = '.widget_main_header';
        var navbarHeight = jQuery('header').outerHeight();
        // jQuery('body').css('padding-top', navbarHeight);
        if (jQuery(window).width() > 1199) {
            var didScroll;
            var lastScrollTop = 0;
            var delta = 5;

            jQuery(window).on('resize', function () {
                var navbarHeight = jQuery('header').outerHeight();
                // jQuery('body').css('padding-top', navbarHeight);
            });


            if ((jQuery(window).scrollTop() > 0)) {
                jQuery('header').addClass('scrolled');
            }

            jQuery(window).scroll(function (event) {
                var headerheightreal = jQuery('header').outerHeight();
                didScroll = true;
                setTimeout(function () {
                    if ((jQuery(window).scrollTop() > 0)) {
                        jQuery('header').addClass('scrolled');
                    }
                }, 250);
                setTimeout(function () {
                    if ((jQuery(window).scrollTop() == 0)) {
                        jQuery('header').removeClass('scrolled');
                    }
                }, 300);
            });

            setInterval(function () {
                if (didScroll) {
                    hasScrolled();
                    didScroll = false;
                }
            }, 250);

            ////////////////
            function hasScrolled() {
                var st = jQuery(this).scrollTop();


                // Make sure they scroll more than delta
                if (Math.abs(lastScrollTop - st) <= delta)
                    return;

                // If they scrolled down and are past the navbar, add class .nav-up.
                // This is necessary so you never see what is "behind" the navbar.
                if (st > lastScrollTop && st > 0) {
                    // Scroll Down
                    var headerheightreal = jQuery('header').outerHeight();
                    jQuery('header').removeClass('nav-down').addClass('nav-up');
                    jQuery('header').css('top', headerheightreal * -1)

                } else {
                    // Scroll Up
                    var headerheightreal = jQuery('header').outerHeight();
                    if (st + jQuery(window).height() < jQuery(document).height()) {
                        jQuery('header').removeClass('nav-up').addClass('nav-down');
                        jQuery('header').css('top', '0')
                    }
                }

                lastScrollTop = st;
            }

        }
    }

function socialMediaSticky(){
  // social media sticky
  var scrollPosition = jQuery('header#header').offset().top;
  if (scrollPosition > 50) {
    // when scroll to bottom of the page
    jQuery('.social-media-top.social-sticky').addClass('visible');
    jQuery('.social-media-top.not-sticky').addClass('invisible');
  } else {
    jQuery('.social-media-top.social-sticky').removeClass('visible');
    jQuery('.social-media-top.not-sticky').removeClass('invisible');
  }
  jQuery(window).on("scroll", function () {
    var scrollPosition = jQuery(window).scrollTop();
    if (scrollPosition > 50) {
      // console.log('social-media sticky');
      // when scroll to bottom of the page
      jQuery('.social-media-top.social-sticky').addClass('visible');
      jQuery('.social-media-top.not-sticky').addClass('invisible');
    } else {
      jQuery('.social-media-top.social-sticky').removeClass('visible');
      jQuery('.social-media-top.not-sticky').removeClass('invisible');
    }
  });
}

function selectCustomNumber(){
  $(".select-custom.numbers .plus").click(function() {
    var item = $(this).closest(".select-custom").find(".selected-item-text");
    item.val(Number(item.val()) + 1);
    let href = $(this).closest('.shopping-adding-section-row').find('.btn-custom').attr('href');
    let newHrefCount = href.replace(/count=\d+/, 'count='+item.val());
    $(this).closest('.shopping-adding-section-row').find('.btn-custom').attr('href', newHrefCount);
    // $(this).closest('.shopping-adding-section-row').find('.btn-custom').addClass('test').attr('data-count', item.val());
    // href.searchParams.set('count', item.val());
    // $(this).closest('.shopping-adding-section-row').find('.btn-custom').data('count', ).
    console.log('number more');
  });
  $(".select-custom.numbers .minus").click(function() {
    var item = $(this).closest(".select-custom").find(".selected-item-text");
    if(item.val() > 1){
      item.val(Number(item.val()) - 1);
      console.log('number less');
    }
    let href = $(this).closest('.shopping-adding-section-row').find('.btn-custom').attr('href');
    let newHrefCount = href.replace(/count=\d+/, 'count='+item.val());
    $(this).closest('.shopping-adding-section-row').find('.btn-custom').attr('href', newHrefCount);
  });
}

function selectCustom() {
  $('.select-custom.normal .selected-item').on('click tap', function () {
    $(this).find('.trigger').toggleClass('active');
    $(this).closest('.select-custom').find('.items-list').slideToggle();
  });
  $('.select-custom.normal .items-list li').on('click tap', function () {
    var activeText = $(this).text();
    $(this).closest('.select-custom').find('.selected-item-text').text(activeText);
    $('.select-custom .items-list li').removeClass('active');
    $(this).addClass('active');
    $('.select-custom .trigger').removeClass('active');
    $(this).closest('.select-custom .items-list').slideUp();
    let href = $(this).closest('.shopping-adding-section-row').find('.btn-custom').attr('href');
    let newHrefVariant = href.replace(/variant=[^&]+/, 'variant='+activeText);
    $(this).closest('.shopping-adding-section-row').find('.btn-custom').attr('href', newHrefVariant);
  });
}

function basketCount() {
  var basketCookie = jQuery.cookie('boxes-basket');
  console.log('basketCookie', basketCookie);

  if (basketCookie !== null) {
    var basketCount = 0;
    if(basketCookie === ''){
      console.log('basket empty');
    }else {
      var basket = JSON.parse(basketCookie);
      $.each( basket, function( key, value ) {
        $.each( value, function( key, value ) {
          var valNumber = parseInt(value);
          basketCount = basketCount + valNumber;
        });
      });
    }
    console.log('elements in basket: '+basketCount);
    $('#header .basket-count-number').text(basketCount);
  }
}
function contactFormPreloader() {
  var preloaderElement = '<div class="contact-preloader"><svg version="1.1" id="L7" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"><path fill="#fff" d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z"><animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="2s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform></path><path fill="#fff" d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z"><animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="-360 50 50" repeatCount="indefinite"></animateTransform></path><path fill="#fff" d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5L82,35.7z"><animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="2s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform></path></svg></div>';
  if($('.wpcf7').length > 0){
    $('.wpcf7').append(preloaderElement);
    // show preloader when click on submit
    var wpcf7Elm = document.querySelector( '.wpcf7' );
    $('.wpcf7-submit').on('click tap',function () {
      $('.contact-preloader').addClass('active');
      $('.wpcf7').addClass('less-opacity');
    });
    // hide preloader after send
    wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
      $('.contact-preloader').removeClass('active');
      $('.wpcf7').removeClass('less-opacity');

    }, false );
    wpcf7Elm.addEventListener( 'wpcf7invalid', function( event ) {
      $('.contact-preloader').removeClass('active');
      $('.wpcf7').removeClass('less-opacity');
    }, false );
    wpcf7Elm.addEventListener( 'wpcf7mailfailed', function( event ) {
      $('.contact-preloader').removeClass('active');
      $('.wpcf7').removeClass('less-opacity');
    }, false );
  }

}

function scrollToBottom() {
  $('.scroll-to-bottom').on('click tap',function () {
    $('html, body').animate({
          scrollTop: $(document).height()-$(window).height()},
        1400,
        "easeOutQuint"
    );
  });
}


